import { render, staticRenderFns } from "./TagItem.vue?vue&type=template&id=1ed1228e&scoped=true&lang=html&"
import script from "./TagItem.vue?vue&type=script&lang=js&"
export * from "./TagItem.vue?vue&type=script&lang=js&"
import style0 from "./TagItem.vue?vue&type=style&index=0&id=1ed1228e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed1228e",
  null
  
)

export default component.exports